import { Link } from 'react-router-dom';

const columns = [
  {
    title: '内容频道',
    links: [
      { label: '电影频道', to: '/category/movie' },
      { label: '剧集频道', to: '/category/tv' },
      { label: '综艺频道', to: '/category/show' },
      { label: '影视资讯', to: '/news' },
    ],
  },
  {
    title: '发现更多',
    links: [
      { label: '最新上线', to: '/category/movie/list?sort=最新上线' },
      { label: '高分推荐', to: '/category/tv/list?sort=评分最高' },
      { label: '我的收藏', to: '/favorites' },
      { label: '站内搜索', to: '/search?q=悬疑' },
    ],
  },
  {
    title: '关于平台',
    links: [
      { label: '关于我们', to: '/about' },
      { label: '联系方式', to: '/about' },
      { label: '活动公告', to: '/news' },
      { label: '意见反馈', to: '/about' },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 w-full bg-primary-950 text-background-100">
      <div className="px-4 py-12 md:px-8 md:py-14">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.4fr_repeat(3,0.8fr)]">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-foreground-950">
                <i className="ri-play-fill text-lg"></i>
              </span>
              <span className="font-display text-lg font-bold text-white">91大神</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-300">
              91大神影视平台聚合高清电影、剧集与综艺资源，提供类型、地区、年份多维筛选与影视资讯，帮助你更快找到今晚想看的那一部。
            </p>
            <p className="mt-4 text-xs leading-relaxed text-background-400">
              本站内容信息仅作介绍与推荐，播放与下载信息以版权方平台说明为准。请支持正版影视内容。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {['ri-wechat-line', 'ri-weibo-line', 'ri-mail-line'].map((icon) => (
                <span
                  key={icon}
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 text-background-200"
                >
                  <i className={`${icon} text-base`}></i>
                </span>
              ))}
            </div>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <h2 className="font-display text-sm font-semibold text-white">{col.title}</h2>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-300 transition-colors hover:text-accent-400"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-white/10 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 91大神影视平台 · 京ICP备00000000号（演示站点）</p>
          <p className="flex flex-wrap items-center gap-3">
            <span>内容聚合演示</span>
            <span className="hidden sm:inline text-white/20">|</span>
            <span>数据均为模拟内容</span>
            <span className="hidden sm:inline text-white/20">|</span>
            <span>更新于 2026-10-18</span>
          </p>
        </div>
      </div>
    </footer>
  );
}